import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { BreadcrumbsContext } from './breadcrumbsContext';

export const BreadcrumbsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [breadcrumb, setBreadcrumb] = useState<ReactNode | null>(null);

  const handleSetBreadcrumb = useCallback((content: ReactNode) => {
    setBreadcrumb(content);
  }, []);

  const clearBreadcrumb = useCallback(() => {
    setBreadcrumb(null);
  }, []);

  const contextValue = useMemo(
    () => ({
      breadcrumb,
      setBreadcrumb: handleSetBreadcrumb,
      clearBreadcrumb,
    }),
    [breadcrumb, clearBreadcrumb, handleSetBreadcrumb]
  );

  return (
    <BreadcrumbsContext.Provider value={contextValue}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};
